import { render } from "./ShiftDetailsSidebar.vue?vue&type=template&id=c00e1226&scoped=true&ts=true"
import script from "./ShiftDetailsSidebar.vue?vue&type=script&lang=ts"
export * from "./ShiftDetailsSidebar.vue?vue&type=script&lang=ts"

import "./ShiftDetailsSidebar.vue?vue&type=style&index=0&id=c00e1226&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00e1226"]])

export default __exports__